<template>
  <div class="overflow-hidden py-4 border-b">
    <div class="float-left text-gray-600">
      <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
        <use xlink:href="/static/img/feather-sprite.svg#eye"/>
      </svg>
    </div>

    <div class="" style="margin-left:50px;">
      <div class="text-sm">

        <template v-if="activity.causer_type == 'App\\Models\\Broker'">
          You viewed

          <a :href="pageLink" class="text-blue-500">{{ page }}</a>
          
          <template v-if="activity.properties.primaryApplicant != null">
            page for client
            
            <a :href="primaryApplicantLink" class="text-blue-500">{{ getApplicantName(activity.properties.primaryApplicant) }}</a>
          </template>
        </template>

        <template v-else>
          Client 
          
          <a :href="primaryApplicantLink" class="text-blue-500">{{ getApplicantName(activity.properties.primaryApplicant) }}</a>
          
          visited 

          <a :href="pageLink" class="text-blue-500">{{ page }}</a> page.
        </template>
      </div>

      <div class="mt-3 text-gray-600">
        {{ activity.created_at }}
      </div>
    </div>
  </div>
</template>

<script>

  import { EventBus } from '@/shared/event-bus';
  

  export default {

    props : {
      activity : {
        type    : Object,
        required: true
      },
    },

    computed : {

      page() {
        if(this.activity.description.indexOf('requirement') > -1) {
          return 'requirement page'
        }

        else if(this.activity.description.indexOf('risk-profile') > -1) {
          return 'risk profile page'
        }

        else if(this.activity.description.indexOf('asset') > -1) {
          return 'assets page'
        }

        else if(this.activity.description.indexOf('liability') > -1) {
          return 'liabilities page'
        }

        else if(this.activity.description.indexOf('expense') > -1) {
          return 'living expenses page'
        }

        else if(this.activity.description.indexOf('document') > -1) {
          return 'documents page'
        }

        else if(this.activity.description.indexOf('welcome') > -1) {
          return 'welcome page'
        }

        else if(this.activity.description.indexOf('dashboard') > -1) {
          return 'dashboard page'
        }
      },

      primaryApplicantLink() {
        if(this.$store.state.view == 'broker') {
          return '/#/broker/client/detail/' + 
                 this.activity.properties.primaryApplicant.client_id + 
                 '/applicant/' + 
                 this.activity.properties.primaryApplicant.id + 
                 '/profile'
        } else {
        return '/#/client/' + 
               this.activity.properties.primaryApplicant.client_id + 
               '/applicant/' + 
               this.activity.properties.primaryApplicant.id + 
               '/profile'
        }

      },
      
      pageLink() {
        let link = this.$store.state.view == 'broker' ? '/#/broker/client/detail/' : '/#/client/'
        
        if(this.activity.description.indexOf('requirement') > -1) {
          return link + this.activity.properties.primaryApplicant.client_id + '/requirement'
        }

        else if(this.activity.description.indexOf('risk-profile') > -1) {
          return link + this.activity.properties.primaryApplicant.client_id + '/risk-profile'
        }

        else if(this.activity.description.indexOf('asset') > -1) {
          return link + this.activity.properties.primaryApplicant.client_id + '/asset'
        }

        else if(this.activity.description.indexOf('liability') > -1) {
          return link + this.activity.properties.primaryApplicant.client_id + '/liability'
        }

        else if(this.activity.description.indexOf('expense') > -1) {
          return link + this.activity.properties.primaryApplicant.client_id + '/expense'
        }

        else if(this.activity.description.indexOf('document') > -1) {
          return link + this.activity.properties.primaryApplicant.client_id + '/document'
        }

        else if(this.activity.description.indexOf('dashboard') > -1) {
          return '/#/broker/dashboard'
        }
      }
    }
  }
</script>

<style scoped>

</style>
